import { useMemo } from 'react';
import designConfg from '@/config/design';
import { spreadsheet as spreadsheetCore } from '@industriousapps/excelkits-core';
import { cellRefsToGridPosition } from '../utils';
const DEFAULT_COLOR = designConfg.colors.gray60;
const {
  getSpreadsheetIndex
} = spreadsheetCore;
// Create a list of selections on config changes
export default function useSelections(_ref) {
  let {
    configs = [],
    activeSheetIndex = 0,
    worksheetData = [],
    worksheetGrid = {}
  } = _ref;
  const selections = useMemo(() => {
    return configs.filter(_ref2 => {
      let {
        cellReferences
      } = _ref2;
      return (// Get selections for active sheet
        getSpreadsheetIndex(cellReferences) === activeSheetIndex
      );
    }).map(_ref3 => {
      let {
        cellReferences,
        active = false,
        color = DEFAULT_COLOR,
        details
      } = _ref3;
      const selection = cellRefsToSelection(cellReferences, worksheetData, worksheetGrid);
      selection.active = active;
      selection.borderColor = color;
      selection.background = addHexAlpha(color, 0.2);
      if (details) selection.details = details;
      return selection;
    }); // TODO:
    // detect a newly "active" selection then
    // if that selection is not visible to the user
    // attempt to scroll to that selection element
    // and center it in the spreadsheet container element
  }, [configs, activeSheetIndex, worksheetGrid, worksheetData]);
  return selections;
} // Convert a spreadsheet cell reference into a selection config

function cellRefsToSelection(cellRefs, worksheetData, worksheetGrid) {
  const {
    width,
    height,
    top,
    left
  } = cellRefsToGridPosition(cellRefs, 0, worksheetData, worksheetGrid);
  return {
    active: false,
    cellRefs,
    width,
    height,
    top,
    left,
    borderColor: '',
    background: ''
  };
} // Add opacity to a HEX color value


function addHexAlpha(color, opacityTarget) {
  // Force ti to be between 0 and 1
  const opacity = Math.round(Math.min(Math.max(opacityTarget || 1, 0), 1) * 255);
  return color + opacity.toString(16).toUpperCase();
}